$('ul.nav li:nth-child(4) a').addClass('active');

$(document).ready(function() {
	$(".news-condensed").dotdotdot({
		ellipsis: '... ',
		wrap: 'word',
		height: 60,
		watch: true,
		lastCharacter: {
			remove: [' ', ',', ';', '.', '!', '?', '/', '-'],
			noEllipsis: []
		}
	});
});